import PropTypes from 'prop-types';
import cx from 'classnames';
import React, { useCallback } from 'react';

const t = {
  no_job: 'No job',
  no_so: 'No SO',
  no_job_or_so: 'No job/SO found',
};

const Row = ({ className, onItemClick, isSelected, option }) => {
  const onRowClick = useCallback(() => {
    onItemClick(option.jobId || option.soId);
  }, [option, onItemClick]);

  const onSoClick = useCallback(
    (e) => {
      e.stopPropagation();
      if (!!option.soId) {
        onItemClick(option.soId);
      }
    },
    [option, onItemClick]
  );

  if (!option) {
    return (
      <div data-testid="row_no-results" className={cx(className)}>
        <div className="row__no-results">{t.no_job_or_so}</div>
      </div>
    );
  }

  return (
    <div
      className={cx(className, 'row', { selected: isSelected })}
      onClick={onRowClick}
      data-testid="row"
    >
      <div className="row__job">
        <span className={cx({ bolded: !option.soBolded })}>{option.jobId || t.no_job}</span>
      </div>
      <div className="row__so">
        <span
          className={cx({ bolded: option.soBolded, clickable: !!option.soId })}
          data-testid="row_so"
          onClick={onSoClick}
        >
          {option.soId || (!!option.soLabel ? '' : t.no_so)}
        </span>
        {option.soLabel}
      </div>
    </div>
  );
};

Row.defaultProps = {
  onItemClick: () => {
    /*noop*/
  },
};

Row.propTypes = {
  onItemClick: PropTypes.func,
  isSelected: PropTypes.bool,
  option: PropTypes.object,
};

export default Row;
